import $ from 'jquery';

$(document).ready(() => {
    let $boxes = $('.header-banner .boxes');
    
    if($boxes) {
        let paddingBottomExtra = 60;
        let marginBottomExtra = 15;

        let adjustBoxes = () => {
            $('.header-banner .boxes .box').css('height', 'auto');

            let maxHeight = 0;
            $('.header-banner .boxes .box').each((i, box) => {
                let boxHeight = $(box).outerHeight();
                if(boxHeight > maxHeight) {
                    maxHeight = boxHeight;
                }
            });

            $('.header-banner .boxes .box').css('height', maxHeight);
            
            let boxesOuterHeight = $boxes.outerHeight();
            let firstBoxHalfHeight = $($('.flip-hover', $boxes)[0]).outerHeight() / 2;

            $boxes.css({
                position: 'absolute',
                top: 'calc(100% - '+firstBoxHalfHeight+'px)',
                left: 0,
                right: 0
            });

            $boxes.parent('.header-banner').css({
                position: 'relative',
                paddingBottom: firstBoxHalfHeight + paddingBottomExtra,
                marginBottom: boxesOuterHeight - firstBoxHalfHeight + marginBottomExtra
            });
        }

        $(window).resize(() => adjustBoxes());
        adjustBoxes();

        setTimeout(() =>  {
            adjustBoxes();
        }, 500);
    }

    //$(selector).offset().top

});


// WEBPACK FOOTER //
// ./scripts/components/headerBanner.js